/**
 * Codes
 */
export class Codes {
  static EXPIRED_TOKEN = 'JWT_1001';
  static INVALID_TOKEN = 'JWT_1002';
}

/**
 * Types
 */
export class Types {
  static EXPIRED_TOKEN = 'ExpiredToken';
  static INVALID_TOKEN = 'InvalidToken';
}

/**
 * Messages
 */
export class Messages {
  static EXPIRED_TOKEN = 'The JWT token is expired';
  static INVALID_TOKEN = 'The JWT token is invalid or malformed';
}
